module.exports = __webpack_public_path__ + "static/media/greenPhone.f866f486.svg";